// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4FosN","col":"styles_col__1jqIx","actions":"styles_actions__3N_xp","conflict":"styles_conflict__1ZYEe"};